/**
 * PhotoLightbox — full-screen overlay for viewing a photo.
 * Tap anywhere to dismiss.
 */
const PhotoLightbox = ({ url, onClose }) => {
  if (!url) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        padding: '20px',
      }}
    >
      <img
        src={url}
        alt="Photo"
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
          borderRadius: '4px',
        }}
      />
    </div>
  );
};

export default PhotoLightbox;
